__turbopack_context__.v({
  "avatar": "HeaderBar-module__zoNWmq__avatar",
  "avatarFallback": "HeaderBar-module__zoNWmq__avatarFallback",
  "avatarImage": "HeaderBar-module__zoNWmq__avatarImage",
  "avatarName": "HeaderBar-module__zoNWmq__avatarName",
  "avatarWrapper": "HeaderBar-module__zoNWmq__avatarWrapper",
  "branding": "HeaderBar-module__zoNWmq__branding",
  "centerNav": "HeaderBar-module__zoNWmq__centerNav",
  "closeButton": "HeaderBar-module__zoNWmq__closeButton",
  "defaultIcon": "HeaderBar-module__zoNWmq__defaultIcon",
  "dropdown": "HeaderBar-module__zoNWmq__dropdown",
  "dropdownItem": "HeaderBar-module__zoNWmq__dropdownItem",
  "header": "HeaderBar-module__zoNWmq__header",
  "left": "HeaderBar-module__zoNWmq__left",
  "logo": "HeaderBar-module__zoNWmq__logo",
  "logoImage": "HeaderBar-module__zoNWmq__logoImage",
  "menuAvatar": "HeaderBar-module__zoNWmq__menuAvatar",
  "menuButton": "HeaderBar-module__zoNWmq__menuButton",
  "menuDropdown": "HeaderBar-module__zoNWmq__menuDropdown",
  "menuItem": "HeaderBar-module__zoNWmq__menuItem",
  "navIcon": "HeaderBar-module__zoNWmq__navIcon",
  "navIcons": "HeaderBar-module__zoNWmq__navIcons",
  "navItem": "HeaderBar-module__zoNWmq__navItem",
  "navLabel": "HeaderBar-module__zoNWmq__navLabel",
  "right": "HeaderBar-module__zoNWmq__right",
  "search": "HeaderBar-module__zoNWmq__search",
  "searchDesktop": "HeaderBar-module__zoNWmq__searchDesktop",
  "searchHeader": "HeaderBar-module__zoNWmq__searchHeader",
  "searchMobileButton": "HeaderBar-module__zoNWmq__searchMobileButton",
  "searchMobileOverlay": "HeaderBar-module__zoNWmq__searchMobileOverlay",
  "searchResults": "HeaderBar-module__zoNWmq__searchResults",
  "searchWrapper": "HeaderBar-module__zoNWmq__searchWrapper",
  "signInButton": "HeaderBar-module__zoNWmq__signInButton",
  "signInIcon": "HeaderBar-module__zoNWmq__signInIcon",
  "siteName": "HeaderBar-module__zoNWmq__siteName",
  "tooltip": "HeaderBar-module__zoNWmq__tooltip",
  "tooltipHidden": "HeaderBar-module__zoNWmq__tooltipHidden",
});
